import { Component, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AuthTypes } from 'app/store/auth/auth.type';
import { logout } from 'app/store/auth/auth.action';
import { tap } from 'rxjs';
import { DialogService } from 'app/services/dialog.service';
import { getAllRouteParams } from 'app/utils/helpers/helper-functions';

@Component({
  selector: 'app-auto-logout-dialog',
  templateUrl: './auto-logout-dialog.component.html',
  standalone: false,
})
export class AutoLogoutDialogComponent implements OnDestroy {
  private timeoutId!: ReturnType<typeof setTimeout>;

  constructor(
    private store: Store,
    private router: Router,
    private actions: Actions,
    private dialogService: DialogService,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<AutoLogoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: any
  ) {}

  ngOnInit(): void {
    const routeParams = getAllRouteParams(this.route);
    const companyID = routeParams['companyID'];
    this.timeoutId = setTimeout(() => {
      this.dialogRef.close();

      this.store.dispatch(logout());

      this.actions
        .pipe(
          ofType(AuthTypes.POST_AUTH_LOGOUT_SUCCESS),
          tap(() => {
            this.dialogService.closeAll();
            this.router.navigate([`${companyID}`]);
          })
        )
        .subscribe();
    }, 3000);

    this.dialogRef.backdropClick().subscribe(() => {
      clearTimeout(this.timeoutId);
    });
  }

  ngOnDestroy() {
    clearTimeout(this.timeoutId);
  }
}
